import { FormControlLabel, Radio, RadioGroup, Stack, Typography } from "@mui/material";
import type { FormAnswerValueDto, FormQuestionTypeConfigDto, RangeFormQuestionTypeConfigDto } from "src/http";
import { TextViewer } from "../textEditor";

interface Props {
  questionTypeConfig: FormQuestionTypeConfigDto;
  answer: FormAnswerValueDto | null;
}

const FormSubmissionAnswer = (props: Props) => {
  switch (props.answer?.type) {
    case "TextInput":
      return <TextViewer value={props.answer.value} />;
    case "MultipleChoice": {
      return <Typography>{props.answer.value.join(", ")}</Typography>;
    }
    case "Range": {
      const questionTypeConfig = props.questionTypeConfig as RangeFormQuestionTypeConfigDto;
      const values: number[] = [];

      for (
        let value = questionTypeConfig.minValue;
        value <= questionTypeConfig.maxValue;
        value += questionTypeConfig.stepValue
      ) {
        values.push(value);
      }

      return (
        <RadioGroup row value={props.answer}>
          <Stack sx={{
            flexGrow: 1
          }}>
            <Stack direction="row" sx={{
              justifyContent: "space-between"
            }}>
              {values.map((value) => (
                <FormControlLabel
                  key={value}
                  value={value}
                  label=""
                  sx={{ mx: -0.5 }}
                  control={<Radio disableRipple />}
                />
              ))}
            </Stack>
            <Stack direction="row" sx={{
              justifyContent: "space-between"
            }}>
              <Typography variant="caption">{questionTypeConfig.minLabel}</Typography>
              <Typography variant="caption">{questionTypeConfig.maxLabel}</Typography>
            </Stack>
          </Stack>
        </RadioGroup>
      );
    }
    default:
      return <Typography variant="placeholder">No answer given.</Typography>;
  }
};

export { FormSubmissionAnswer };
